// src/components/services/InstitutionsTab.jsx
import React from "react";
import { BRAND } from "../../config/brandConfig";
import Card from "../Card";

function InstitutionsTab() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr)",
        gap: "1.75rem",
      }}
    >
      <div style={{ fontSize: 14, color: "#475569" }}>
        <p>
          For corporates and institutions, we provide portfolio construction and
          oversight that balances capital preservation with mandate-driven
          returns.
        </p>
        <ul style={{ paddingLeft: "1.1rem" }}>
          <li>Investment policy statement design</li>
          <li>Manager selection and due diligence</li>
          <li>Ongoing portfolio monitoring and reporting</li>
          <li>Liquidity and cash laddering strategies</li>
        </ul>
      </div>

      <Card
        title="Who this is for"
        body="Corporate treasuries, non-profits, and institutions that need disciplined, transparent oversight of investable assets."
        tag="Institutions"
      />
    </div>
  );
}

export default InstitutionsTab;
